

define(['squid/index', './directive'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-member-sepa.sepaAgreement.route', ['squid', 'xo-member-sepa.sepaAgreement.directive']).factory('$XOSepaAgreementRoute', function ($ComponentRoute) {
        return $ComponentRoute.extend('XOSepaAgreementRoute', {
            name: 'sepaAgreement',

            directive: 'xo-sepa-agreement',
            titleContent: 'directDebitAgreement.sepaTitle',

            trackingData: {
                fptiState: 'sepa_agreement'
            },

            loginRequired: true,

            children: []
        });
    });
});


/*****************
 ** WEBPACK FOOTER
 ** ./components/xo-wallet-components/src/member-sepa/sepaAgreement/route.js
 ** module id = 426
 ** module chunks = 1
 **/